<agc-form [formGroup]="form" (submit)="submit()">
  <div class="row m-b-20">
    <div class="col-md-12">
      <h3 class="text-center">Reset Password</h3>
    </div>
  </div>

  <agc-form-field>
    <input type="password" formControlName="password" autocomplete="new-password" class="form-control" required placeholder="New Password">
  </agc-form-field>

  <agc-form-field>
    <input type="password" formControlName="confirmPassword" autocomplete="new-password" class="form-control" required placeholder="Confirm Password">
  </agc-form-field>

  <div class="m-t-30">
    <button type="submit" class="btn btn-primary btn-md btn-block waves-effect waves-light text-center m-b-20">Submit</button>
  </div>

  <hr>

  <p class="text-inverse text-center m-b-0">
    <a [routerLink]="['/']"><b class="f-w-600">Click here to Sign In</b></a>
  </p>
</agc-form>
